import React, { useState } from "react";
import GenericTableHeader from "./GenericTableHeader";
import GenericTableRow from "./GenericTableRow";
import "./ResizableDraggableTable.css";
import GenericOverviewSideCard from "../GenericOverviewSideCard";
import SideCardHorizntalTabComp from "../sideCardHorizontalTabs/SideCardHorizntalTabComp";
import TablePaginationComp from "./TablePaginationComp";
import IOSSpinner from "../../../HtmlElements/IOSSpinner";
import PaginationComp from "./PaginationComp";




const ResizableDraggableTable = ({disableSort,sortState,updateSortKey,updateSortConfig,initialColumns,tabData,sideCardTabConfig,showMoreModal, setShowMoreModal,onModalClose,titleForSideCard=null,activeTab, setActiveTab,loading,disableHeader=false ,currentPage,itemsPerPage,onPageChange,totalItems,onRowsPerPageChange, enablePagination=false,oppName,customComp=null,minWidthForDrawer="50%",allowSelection=false, toggleSelectAll,  selectedRows=[], setSelectedRows=()=>{},isAllSelected,isIndeterminate,loadingRows=5}) => {
  // console.log("ResizableDraggableTable",activeTab,setActiveTab)
  const [columns, setColumns] = useState(initialColumns);

  const handleResize = (index, e) => {
    e.preventDefault();
    e.stopPropagation();
    const startX = e.clientX;
    const startWidth = columns[index].width;

    const onMouseMove = (e) => {
      const newWidth = Math.max(50, startWidth + e.clientX - startX);
      setColumns((cols) => {
        const newCols = [...cols];
        newCols[index] = { ...newCols[index], width: newWidth };
        return newCols;
      });
    };

    const onMouseUp = () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };

    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
  };

  return (
    <>
     <div className="custom-resizable-table-container">
      <table className="custom-resizable-table">
        <thead>
          <tr className="custom-resizable-table-header">
            {!disableHeader && (
              <GenericTableHeader
                disableSort={disableSort}
                sortState={sortState}
                columns={columns}
                onResize={handleResize}
                updateSortKey={updateSortKey}
                updateSortConfig={updateSortConfig}
                allowSelection={allowSelection}
                toggleSelectAll={toggleSelectAll}
                isIndeterminate={isIndeterminate}
                isAllSelected={isAllSelected}
              />
            )}
          </tr>
        </thead>
        <tbody>
          {!loading
            ? tabData?.map((row, idx) => (
                <GenericTableRow
                  key={idx}
                  row={row}
                  columns={columns}
                  allowSelection={allowSelection}
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                />
              ))
            : [...Array(loadingRows)]?.map((_, rowIdx) => (
                <tr key={`skeleton-${rowIdx}`} className="resize-table-skeleton-row">
                  {columns?.map((col, colIdx) => (
                    <td key={`skeleton-cell-${rowIdx}-${colIdx}`} style={{ width: col.width }}>
                      <div className="resize-table-skeleton-cell" />
                    </td>
                  ))}
                </tr>
              ))}
        </tbody>
      </table>
    </div>
      {enablePagination && <div className="generic-table_pagination-comp-wrapper">
        <PaginationComp 
            currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  onPageChange={onPageChange}
                  totalItems={totalItems}
                  onRowsPerPageChange={onRowsPerPageChange}/>
        </div>}
      <GenericOverviewSideCard
      minWidthForDrawer={minWidthForDrawer}
        showMoreModal={showMoreModal}
        setShowMoreModal={setShowMoreModal}
        onModalClose={onModalClose}
        titleForSideCard={titleForSideCard}
        comp={
          customComp != null ? (
            customComp
          ) : (
            <SideCardHorizntalTabComp
              tabConfig={sideCardTabConfig}
              showMoreModal={showMoreModal}
              setShowMoreModal={setShowMoreModal}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              onPageChange
              oppName={oppName}
            />
          )
        }
        disableXbtn
      />
    </>
  );
};

export default ResizableDraggableTable;
